var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_321_886)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.51029 30.212H7.90145V17.1182L0.200195 11.3423V27.9012C0.200103 28.2047 0.25981 28.5053 0.375906 28.7857C0.492001 29.0661 0.66221 29.3208 0.876806 29.5354C1.0914 29.75 1.34618 29.9202 1.62658 30.0363C1.90698 30.1524 2.2068 30.2121 2.51029 30.212Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3857 30.212H31.7769C32.0804 30.2122 32.381 30.1526 32.6615 30.0365C32.942 29.9205 33.1969 29.7503 33.4115 29.5357C33.6262 29.3211 33.7965 29.0663 33.9126 28.7858C34.0288 28.5054 34.0885 28.2048 34.0884 27.9012V11.3423L26.3857 17.1182",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3857 7.10603V17.1181L34.0877 11.3421V8.26107C34.0877 5.40382 30.8259 3.77433 28.5426 5.48854",
    fill: "#FBBC04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.90137 17.1189V7.10547L17.1446 14.0379L26.3863 7.10617V17.1182L17.1446 24.0499",
    fill: "#EA4335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.198948 8.26107V11.3421L7.9002 17.1181V7.10603L5.74402 5.48854C3.45652 3.77433 0.198242 5.40382 0.198242 8.26107",
    fill: "#C5221F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_321_886"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33.8889,
    height: 33.8889,
    fill: "white",
    transform: "translate(0.200195 0.555664)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.db1db5632e1dea5def9c8cef0112822f.svg";
export { ForwardRef as ReactComponent };